/*=============================================== AlertPage ===============================================*/

import { Alert, Text, Flexbox, Button } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { commonProps } from "data"

const AlertPage = () => {
    const items: ItemType[] = [
        {
            title: "With text",
            content: <Alert color="success">Alert</Alert>,
            code: '<Alert color="success">Alert</Alert>',
        },
        {
            title: "With more content",
            content: (
                <Alert color="danger">
                    <Text>Alert with button</Text>

                    <Flexbox alignItems="center" gap="xs">
                        <Button color="danger">Button</Button>
                        <Button variant="transparent">Button</Button>
                    </Flexbox>
                </Alert>
            ),
            code: '<Alert color="danger">\n    <Text>Alert with button</Text>\n\n    <Flexbox alignItems="center" gap="xs">\n        <Button color="danger">Button</Button>\n        <Button variant="transparent">Button</Button>\n    </Flexbox>\n</Alert>',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "color",
            type: "string",
            possible: commonProps.colorsHover,
            default: "primary",
        },
        {
            subtitle: "maxWidth",
            type: "number",
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default AlertPage
